import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";
const moduleName = "fiance";

store.registerModule(moduleName, {
  namespaced: true,
  state: {},
  actions: {
    //获取收付款单分页列表
    async getFinancePage({ commit }, payload) {
      let result = await api.get(
        `/api/Finance/GetPage?${queryString.stringify(payload)}`
      );
      return result;
    },
    // 获取购销单财务列表
    async getFinanceStock({ commit }, payload) {
      let result = await api.get(
        `/api/Finance/GetStock?${queryString.stringify(payload)}`
      );
      return result;
    },
    // 根据Id获得收付款单详情
    async getFinanceDetail({ commit }, payload) {
      let result = await api.get(`/api/Finance/${payload}`);
      return result.data;
    },
    // 修改收付款单
    async editFinance({ commit }, payload) {
      let result = await api.put(`/api/Finance`, payload);
      return result;
    },
    // 新增收付款单
    async addFinance({ commit }, payload) {
      let result = await api.post(`/api/Finance`, payload);
      return result;
    },
    // 删除收付款单
    async deleteFinance({ commit }, payload) {
      let result = await api.delete(`/api/Finance/${payload}`);
      return result;
    },
    //获取部门
    async getDepartMent({ commit }, payload) {
      let result = await api.get(
        `/api/User/GetDepartment?${queryString.stringify(payload)}`
      );
      return result;
    },

    //收/付款明细报表
    async getFinanceDetailReport({ commit }, payload) {
      let result = await api.get(
        `/api/Finance/GetFinanceDetailReport?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //已收/付款列表
    async getFinanceDetailReportEx({ commit }, payload) {
      let result = await api.get(
        `/api/Finance/GetFinanceDetailReportEx?${queryString.stringify(
          payload
        )}`
      );
      return result.data;
    },
    //获取收付账款汇总表
    async getFinanceSummary({ commit }, payload) {
      let result = await api.get(
        `api/Finance/GetFinanceSummary?${queryString.stringify(payload)}`
      );
      return result.data;
    },
  },
});

export default moduleName;
